import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { PageHeader } from "@/components/PageHeader";
import { DispatchWizard } from "@/components/fleet/DispatchWizard";
import { S } from "@/lib/strings";

export function Dispatch() {
  const [params] = useSearchParams();

  // `/devices` and a device's header hand a preselection over in the URL, so a
  // dispatch that started from a filtered table keeps its context across the
  // navigation instead of making the operator tick the same rows twice.
  const initialDeviceIds = useMemo(() => {
    const raw = params.get("devices");
    if (!raw) return [];
    return raw.split(",").map((s) => s.trim()).filter(Boolean);
  }, [params]);

  return (
    <>
      <PageHeader title={S.dispatchTitle} hint={S.dispatchHint} />
      <div className="max-w-4xl">
        <DispatchWizard
          key={initialDeviceIds.join(",")}
          initialDeviceIds={initialDeviceIds}
        />
      </div>
    </>
  );
}
